export const LandingPageHeroContentPTBRTranslations = {
  landingPageHeroParagraph:
    'Melhoramos a tomada de decisão das empresas através de dados, inteligência artificial e planejamento integrado.',
  landingPageHeroImgAlt:
    'Imagem de algumas funcionalidades do produto como o chat 4i, projetos, indicadores e gráficos',
};
